/**
 * Winwin — Selloff bidder registration
 */
(function () {
  var submitting = false;

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function setOptions(select, items, placeholder, valueKey, labelKey) {
    if (!select) return;
    var html = '<option value="" disabled selected>' + escapeHtml(placeholder) + '</option>';
    (items || []).forEach(function (item) {
      html += '<option value="' + escapeHtml(item[valueKey]) + '">' + escapeHtml(item[labelKey]) + '</option>';
    });
    select.innerHTML = html;
  }

  function fieldWrap(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    if (!el) return null;
    return el.closest('.date-parts') || el.closest('.field') || el.closest('.check') || el.parentElement;
  }

  function clearFieldErrors(form) {
    form.querySelectorAll('.is-invalid').forEach(function (node) {
      node.classList.remove('is-invalid');
    });
    form.querySelectorAll('.field-error').forEach(function (node) {
      node.remove();
    });
  }

  function showFieldError(form, field, message) {
    var wrap = fieldWrap(form, field);
    if (!wrap) return null;
    wrap.classList.add('is-invalid');
    var err = document.createElement('p');
    err.className = 'field-error';
    err.textContent = message;
    wrap.appendChild(err);
    return wrap.querySelector('input, select, textarea') || wrap;
  }

  function showErrors(box, errors, form) {
    clearFieldErrors(form);
    if (box) {
      box.hidden = true;
      box.innerHTML = '';
    }
    var list = (errors || []).map(function (e) {
      if (typeof e === 'string') return { text: e, field: '' };
      return { text: (e && e.text) || '', field: (e && e.field) || '' };
    }).filter(function (e) { return e.text; });

    if (!list.length) return;

    var firstFocus = null;
    var unmapped = [];
    list.forEach(function (item) {
      if (item.field) {
        var focusEl = showFieldError(form, item.field, item.text);
        if (focusEl && !firstFocus) firstFocus = focusEl;
      } else {
        unmapped.push(item.text);
      }
    });

    if (unmapped.length && box) {
      box.hidden = false;
      box.innerHTML = '<ul>' + unmapped.map(function (t) {
        return '<li>' + escapeHtml(t) + '</li>';
      }).join('') + '</ul>';
    }

    var target = firstFocus || (box && !box.hidden ? box : null);
    if (target && typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (firstFocus && typeof firstFocus.focus === 'function') {
      try { firstFocus.focus({ preventScroll: true }); } catch (e) { firstFocus.focus(); }
    }
  }

  function clientValidate(form, payload) {
    var errors = [];
    function need(field, message) {
      if (!payload[field] || String(payload[field]).trim() === '') {
        errors.push({ field: field, text: message, class: 'error' });
      }
    }
    need('title', 'Title is required.');
    need('firstname', 'First name is required.');
    need('lastname', 'Last name is required.');
    need('birthdate', 'Birthdate is required.');
    need('email', 'Email is required.');
    need('password', 'Password is required.');
    need('street1', 'Street address is required.');
    need('city', 'City is required.');
    need('zip', 'ZIP / postal code is required.');
    need('countries_idcountry', 'Country is required.');
    if (payload.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
      errors.push({ field: 'email', text: 'Please enter a valid email address.', class: 'error' });
    }
    if (payload.password && String(payload.password).length < 8) {
      errors.push({ field: 'password', text: 'Password must be at least 8 characters.', class: 'error' });
    }
    if (!payload.phone && !payload.mobile) {
      errors.push({ field: 'phone', text: 'At least one phone number is required.', class: 'error' });
    }
    if (!payload.accept_pp) {
      errors.push({ field: 'accept_pp', text: 'You must accept the privacy policy and marketing communications.', class: 'error' });
    }
    return errors;
  }

  function formPayload(form) {
    var fd = new FormData(form);
    function val(name) {
      var v = fd.get(name);
      return v == null ? '' : String(v).trim();
    }
    return {
      title: val('title'),
      firstname: val('firstname'),
      lastname: val('lastname'),
      birthdate: val('birthdate'),
      company: val('company'),
      vat_number: val('vat_number'),
      email: val('email'),
      password: val('password'),
      email_no_marketing: 0,
      street1: val('street1'),
      street2: val('street2'),
      city: val('city'),
      zip: val('zip'),
      state_region: val('state_region'),
      pobox: val('pobox'),
      countries_idcountry: val('countries_idcountry'),
      phone: val('phone'),
      mobile: val('mobile'),
      language: val('language') || '1',
      accept_pp: (function () {
        var el = form.querySelector('[name="accept_pp"]');
        return el && el.checked ? 1 : 0;
      })()
    };
  }

  async function loadOptions(root) {
    var apiBase = (window.WinwinApi && window.WinwinApi.baseFrom ? window.WinwinApi.baseFrom(root) : (root.dataset.apiDirect || 'https://api.winwingeneve.ch').replace(/\/$/, ''));
    if (apiBase.indexOf('onrender.com') !== -1) apiBase = 'https://api.winwingeneve.ch';
    var res = await fetch(apiBase + '/register/options', {
      credentials: 'include',
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) throw new Error('options HTTP ' + res.status);
    return res.json();
  }

  async function init(root) {
    var form = root.querySelector('[data-register-form]');
    if (!form || form.dataset.registerBound === '1') return;
    form.dataset.registerBound = '1';

    var errorBox = root.querySelector('[data-register-errors]');
    var successBox = root.querySelector('[data-register-success]');
    var submitBtn = form.querySelector('[type="submit"]');
    var titleSelect = form.querySelector('[name="title"]');
    var countrySelect = form.querySelector('[name="countries_idcountry"]');
    var languageInput = form.querySelector('[name="language"]');
    var apiDirect = (window.WinwinApi && window.WinwinApi.baseFrom ? window.WinwinApi.baseFrom(root) : (root.dataset.apiDirect || 'https://api.winwingeneve.ch').replace(/\/$/, ''));
    if (apiDirect.indexOf('onrender.com') !== -1) apiDirect = 'https://api.winwingeneve.ch';

    try {
      var options = await loadOptions(root);
      setOptions(titleSelect, options.titles || [], 'Please select a title', 'id', 'label');
      setOptions(countrySelect, options.countries || [], 'Please select a country', 'id', 'name');
      if (languageInput && options.default_language) {
        languageInput.value = String(options.default_language);
      }
      if (countrySelect) {
        var ch = Array.prototype.find.call(countrySelect.options, function (o) {
          return /switzerland/i.test(o.textContent || '');
        });
        if (ch) {
          countrySelect.querySelector('option[value=""]').removeAttribute('selected');
          ch.selected = true;
          countrySelect.value = ch.value;
        }
      }
    } catch (err) {
      console.error('[winwin register]', err);
      showErrors(errorBox, [{ text: 'Could not load registration options. Please refresh and try again.' }], form);
    }

    if (window.WinwinDateParts) {
      window.WinwinDateParts.bind(form);
    }

    if (window.WinwinAddressAutofill) {
      window.WinwinAddressAutofill.bindForm(form);
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (submitting) return;

      var payload = formPayload(form);
      var localErrors = clientValidate(form, payload);
      if (localErrors.length) {
        showErrors(errorBox, localErrors, form);
        return;
      }

      submitting = true;
      showErrors(errorBox, [], form);
      if (successBox) successBox.hidden = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.label = submitBtn.dataset.label || submitBtn.textContent;
        submitBtn.textContent = 'Submitting…';
      }

      try {
        var res = await fetch(apiDirect + '/register', {
          method: 'POST',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        var data = await res.json().catch(function () { return null; });
        if (!res.ok || !data || data.success !== true) {
          submitting = false;
          showErrors(errorBox, (data && data.errors) || [{ text: (data && data.error) || 'Registration failed.' }], form);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.dataset.label || 'Submit registration →';
          }
          return;
        }

        // Success: keep button disabled and stay on confirmation screen (no account redirect).
        form.hidden = true;
        if (successBox) {
          successBox.hidden = false;
          var msg = successBox.querySelector('[data-register-success-text]');
          if (msg && data.message) msg.textContent = data.message;
          successBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } catch (err) {
        console.error('[winwin register]', err);
        submitting = false;
        showErrors(errorBox, [{ text: 'Network error. Please try again.' }], form);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.label || 'Submit registration →';
        }
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-register-root]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
